import React, { createContext, useContext } from 'react';
import filterStore from './FilterStore';
import jobPostingStore from './JobPostingStore';
import jobApplicantStore from './JobApplicantStore';
import staticDataStore from './StaticDataStore';
import locationServiceStore from './LocationServiceStore';
import recentlyContactedStore from './RecentlyContactedStore';
import favoritesStore from './FavoritesStore';
import notificationStore from './NotificationStore';
import authStore from './AuthStore';
import recommendedCandidatesStore from './RecommendedCandidatesStore';
import jobPostingNotificationsStore from './JobPostingNotificationsStore';
import bulkJobInvitationStore from './BulkJobInvitationStore';
import bulkJobInvitationNotificationStore from './BulkJobInvitationNotificationStore';
import companyProfileStore from './CompanyProfileStore';

export const StoreContext = createContext({});

export const useStore = () => useContext(StoreContext);

const StoreProvider = ({ children }) => {

  return (
    <StoreContext.Provider
      value={{
        authStore,
        filterStore,
        jobPostingStore,
        staticDataStore,
        recentlyContactedStore,
        favoritesStore,
        jobApplicantStore,
        locationServiceStore,
        notificationStore,
        recommendedCandidatesStore,
        jobPostingNotificationsStore,
        bulkJobInvitationStore,
        bulkJobInvitationNotificationStore,
        companyProfileStore
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export default StoreProvider;
